import React, { useState } from 'react';
import { initiateGoogleOAuth, initiateLinkedInOAuth } from '../../services/oauthService';
import { toast } from 'react-toastify';
import './oauth-buttons.css';

interface OAuthButtonsProps {
  loading?: boolean;
  layout?: 'stacked' | 'compact';
  mode?: 'login' | 'register';
}

const OAuthButtons: React.FC<OAuthButtonsProps> = ({
  loading = false,
  layout = 'compact',
  mode = 'login',
}) => {
  const [googleLoading, setGoogleLoading] = useState(false);
  const [linkedinLoading, setLinkedinLoading] = useState(false);

  const handleGoogleClick = async () => {
    setGoogleLoading(true);
    try {
      await initiateGoogleOAuth(mode);
    } catch (error: any) {
      setGoogleLoading(false);
      toast.error(error.message || 'Failed to start Google login');
    }
  };

  const handleLinkedInClick = async () => {
    setLinkedinLoading(true);
    try {
      await initiateLinkedInOAuth(mode);
    } catch (error: any) {
      setLinkedinLoading(false);
      toast.error(error.message || 'Failed to start LinkedIn login');
    }
  };

  return (
    <div
      className={`oauth-buttons-container${
        layout === 'stacked' ? ' oauth-buttons-container--stacked' : ''
      }`}
    >
      <div className="oauth-divider">
        <span className="oauth-divider-text">Or continue with</span>
      </div>

      <div className="oauth-buttons-wrapper">
        <button
          type="button"
          onClick={handleGoogleClick}
          disabled={googleLoading || loading}
          className="oauth-google-button-custom"
          title="Sign in with Google"
        >
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          <span>
            {googleLoading
              ? 'Redirecting...'
              : layout === 'stacked'
                ? 'Continue with Google'
                : 'Google'}
          </span>
        </button>

        <button
          type="button"
          onClick={handleLinkedInClick}
          disabled={linkedinLoading || loading}
          className="oauth-linkedin-button"
          title="Sign in with LinkedIn"
        >
          <svg
            className="linkedin-svg-icon"
            viewBox="0 0 24 24"
            width="20"
            height="20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M20.447 20.452H17.21v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.004V9h3.104v1.561h.045c.433-.82 1.492-1.688 3.067-1.688 3.278 0 3.879 2.158 3.879 4.964v6.615zM5.337 7.433a1.804 1.804 0 1 1 0-3.608 1.804 1.804 0 0 1 0 3.608zM6.956 20.452H3.72V9h3.237v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.727v20.545C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.273V1.727C24 .774 23.2 0 22.222 0z" />
          </svg>
          <span>
            {linkedinLoading
              ? 'Redirecting...'
              : layout === 'stacked'
                ? 'Continue with LinkedIn'
                : 'LinkedIn'}
          </span>
        </button>
      </div>
    </div>
  );
};

export default OAuthButtons;
